module.exports = __webpack_public_path__ + "static/media/sell_start_service_teach_4.d0b3bb34.jpg";